module.exports = __webpack_public_path__ + "img/mc-yr1.76b6f948.gif";